// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","load":"Button_load__LCTld"};